import { NgRedux } from '@ptl/angular-redux-store';
import { Component } from '@angular/core';
import { UserInfoStateStructure, LOGIN_INFO_REDUCER_NAME } from '@ptl/account-management';
import { FormComponentLookup, FormNavigationConfig, DefaultFormConfig, FormPageComponentClass } from '@ptl/forms';
import { PtlNotificationService, PtlNotificationStyle } from '@ptl/global-components';
import { StateStructure } from '@ptl/state';
import { ReducerUtilityService } from '../../../../shared/utility-services/reducer-utility.service';
import { SendSoaRequest, SoaFormState } from '../interfaces/soa.interface';
import { resetSoaState, SOA_STATE } from '../reducer/soa.reducer';
import { SoaService } from '../services/soa.service';

@FormComponentLookup('page-send-soa')
@Component({
    selector: 'app-page-send-soa',
    templateUrl: './page-send-soa.component.html',
    styleUrls: ['./page-send-soa.component.scss'],
    standalone: false
})
export class SendSoaPageComponent extends FormPageComponentClass<FormNavigationConfig> {

  isLoading = false;

  constructor(
    private reducer: ReducerUtilityService,
    private soaService: SoaService,
    private ptlNotificationService: PtlNotificationService,
    protected ngRedux: NgRedux<StateStructure>) {
    super();
  }

  ngOnInit(): void {
    this.initPageConfig();
  }

  submitHook(formConfig) {
    return new Promise((resolve, reject) => {
      this.isLoading = true;

      this.soaService.sendSoa(this.getSoaPayload()).then((response) => {
        if (response?.payload?.messageSent == true) {
          this.ptlNotificationService.open({
            title: 'Success',
            content: 'Your Scope of Appointment (SOA) was sent!',
            primaryButtonText: 'OK',
            notificationStyle: PtlNotificationStyle.SUCCESS
          });
          
          this.ngRedux.dispatch(resetSoaState());
          this.pageFormGroups[SOA_STATE].reset();

          resolve(true);
        }
        else {
          this.soaService.showGenericError();

          reject();
        }
      })
      .finally(() => {
        this.isLoading = false
      });
    });
  }

  getSoaPayload(): SendSoaRequest {
    const soaState: SoaFormState = this.reducer.getPayloadState(SOA_STATE);
    const loginInfo: UserInfoStateStructure = this.reducer.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);

    return {
      baseMessage: {},
      payload: {
        member: false,
        deliveryRecipient: soaState.customerEmailAddress,
        deliveryMethod: "Email",
        templateName: "ProducerSharedESOAMedicareBlank",
        memberProfileId: "",
        groupNumber: "",
        umi: "",
        firstName: soaState.customerFirstName,
        lastName: soaState.customerLastName,
        dob: "",
        etAttributes: [
            {
                name: "Agent_Name",
                value: loginInfo.userInfo.firstName
            },
            {
                name: "Brand_Name",
                value: soaState.county.region
            },
            {
                name: "County",
                value: soaState.county.county
            },
            {
                name: "user_ID",
                value: loginInfo.userId
            },
            {
                name: "EmailTypePreference",
                value: "ELECTRONIC_SCOPE_OF_APPOINTMENT"
            }
        ]
      }
    };
  }
}
